module.exports = __webpack_public_path__ + "img/Accessoires_gateaux.1266de4.png";